require('./RASuitabilityTestFailureDisclaimerModal.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');

// @common
const OKModal = require('commonsComponents/OKModal');
const { OKMessage } = require('commonsComponents/OKMessage');
const { OKButton } = require('components/commons/OKButton/OKButton');
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');

// @components
const RAStrategyModalCards = require('../RAStrategyModalCards/RAStrategyModalCards');

// @utilites
const { FormattedText, formatText } = require('core/i18n').i18n;

class RASuitabilityTestFailureDisclaimerModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showModal: this.props.modalIsOpen,
        };

        this.handleCloseModal = this.handleCloseModal.bind(this);
    }

    handleCloseModal() {
        this.setState({
            showModal: false,
        });
    }

    buildContent() {
        const disclaimer = __CONTACT_CENTER__ ? (
            <BlockInfo>
                <p>
                    <FormattedText value="raSuitabilityTest-testFailureDisclaimer_modalDisclaimerCC" />
                </p>
            </BlockInfo>
        ) : (
            <OKMessage type="warning">
                <p>
                    <FormattedText value="raSuitabilityTest-testFailureDisclaimer_modalDisclaimer" />
                </p>
            </OKMessage>
        );
        return (
            <div className="ra-suitability-test-failure-disclaimer-modal">
                <p>
                    <FormattedText value="raSuitabilityTest-testFailureDisclaimer_modalContent" />
                </p>
                <div className="ra-suitability-test-failure-disclaimer-modal__content-cards">
                    <RAStrategyModalCards
                        newResultCard={0}
                        oldResultCard={0}
                        allDisabled
                    />
                </div>
                <div className="ra-suitability-test-failure-disclaimer-modal__content-disclaimer">
                    {disclaimer}
                </div>
            </div>
        );
    }

    render() {
        const { onHandleReviseSuitabilityTest } = this.props;
        const contentFooter = (
            <div className="ra-suitability-test-failure-disclaimer-modal__footer">
                <div className="ra-suitability-test-failure-disclaimer-modal__button-understand">
                    <OKButton
                        modifier="secondary"
                        onClick={this.handleCloseModal}
                    >
                        <FormattedText value="raSuitabilityTest-testFailureDisclaimer_modalButtonContinue" />
                    </OKButton>
                </div>
                <div className="ra-suitability-test-failure-disclaimer-modal__button-review-test">
                    <OKButton
                        modifier="primary"
                        onClick={onHandleReviseSuitabilityTest}
                    >
                        <FormattedText value="raSuitabilityTest-testFailureDisclaimer_modalButtonReviewTest" />
                    </OKButton>
                </div>
            </div>
        );
        return (
            <OKModal
                isOpen={this.state.showModal}
                title={formatText(
                    'raSuitabilityTest-testFailureDisclaimer_modalTitle',
                )}
                titleAlignment="center"
                onCloseCallback={this.handleCloseModal}
                content={this.buildContent()}
                size="large"
                contentFooter={contentFooter}
            />
        );
    }
}

RASuitabilityTestFailureDisclaimerModal.propTypes = {
    modalIsOpen: PropTypes.bool.isRequired,
    onHandleReviseSuitabilityTest: PropTypes.func.isRequired,
};

module.exports = RASuitabilityTestFailureDisclaimerModal;
